const AppConfigMapFile = require('./AppConfig.json');

export enum AppConfigMapKey {
    ASN_TEMPLATE_URI = "asnTemplateUri",
    OVERRIDE_TEMPLATE_URI = "overrideTemplateUri",
    BOOKING_TEMPLATE_URI = "bookingTemplateUri",
    ASN_WITHOUT_BOOKING_USER_GUIDE_URI = "asnWithoutBookingUserGuideUri",
    BOOKING_USER_GUIDE_URI = "bookingUserGuideUri",
    DMS_USER_GUIDE_URI = "dmsUserGuideUri",
    USER_GUIDE_URI_MANDARIN = "mandarinUserGuideUri",
    TERMS_AND_CONDITIONS_URI = "acceptTermsAndConditionsUri",
    SHIPMENT_PLANS_URI = "shipmentPlansUri",
    ENABLE_SEARCH_FEATURE = "enableSearchFeature",
    ENABLE_UPLOAD_ASN = "enableUploadAsn",
    ENABLE_CREATE_BOOKING = "enableCreateBooking",
    ENABLE_UPDATE_BOOKING = "enableUpdateBooking",
    ENABLE_EXPEDITE_BOOKING = "enableExpediteBooking",
    ENABLE_EDIT_FEATURE = "enableEditFeature",
    ENABLE_CANCEL_FEATURE = "enableCancelFeature",
    ENABLE_ASN_OVER_BOOKING_FEATURE = "enableAsnOverBookingFeature",
    ENABLE_PACKAGING_DETAILS_CARD = "enablePackagingDetailsCard",
    ENABLE_DOWNLOAD_FEATURE = "enableDownloadShipmentsFeature",
    ENABLE_SUBSCRIPTION_FEATURE = "enableSubscriptionFeature",
    ENABLE_DMS = "enableDms",
    ARGO_PORTAL_URL = "argoPortalUrl",
    TICKET_URL = "simUrl",
    WEBINAR_VIDEO_LINK_ENGLISH = "englishWebinarVideoLink",
    WEBINAR_VIDEO_LINK_MANDARIN = "mandarinWebinarVideoLink",
    ENABLE_SEARCH_ERROR_DATA = "enableSearchErrorData",
    ENABLE_LMDP = "enableLmdp",
    ENABLE_LAST_MILE_HUB_VIEW = "enableLastMileHubView",
    ENABLE_LAST_MILE_HUB_VIEW_IN_NAV_BAR = "enableLastMileHubViewInNavBar",
    ENABLE_BLOCKED_AND_EIGHT_WEEK_DELIVERY = "enableBlockedAndEightWeekDelivery",
    ENABLE_SHIPPING_CONFIGURATIONS = "enableShippingConfigurationPage",
    ENABLE_SHIPMENTS_DOWNLOAD_PAGE = "enableShipmentsDownloadPage",
    ENABLE_SHIPPING_CONFIGURATIONS_IN_NAV_BAR = "enableShippingConfigurationsInNavBar",
    ENABLE_SHIPMENTS_DOWNLOAD_PAGE_IN_NAV_BAR = "enableShipmentsDownloadPageInNavBar",
    ENABLE_PLANNER_AUDIT_HISTORY = "enablePlannerAuditHistory",
    ENABLE_WDD = "enableWDD",
    ENABLE_ROUTE_CONFIG = "enableRouteConfig",
    ENABLE_ROUTE_EXPEDITE = "enableRouteExpedite",
    ENABLE_DOCUMENT_REPOSITORY_FEATURE = "enableDocumentRepositoryFeature",
    ENABLE_EDGE_SITES_FEATURE = "enableEdgeSitesFeature",
    BULK_ACTION_HOLD_TEMPLATE_URI = "bulkActionHoldTemplateUri",
    BULK_ACTION_RESUME_TEMPLATE_URI = "bulkActionReleaseTemplateUri",
    BULK_ACTION_ROUTE_REPLAN_TEMPLATE_URI = "bulkActionRouteReplanTemplateUri",
    ENABLE_BULK_ACTION_ROUTE_REPLAN = "enableBulkActionRouteReplan",
    ENABLE_BULK_ACTIONS_IN_NAV_BAR = "enableBulkActionsInNavBar",
    ENABLE_COMPLETE_PACKAGING_INFO = "enableCompletePackagingInfo",
    ENABLE_BULK_EDIT = "enableBulkEdit",
    ENABLE_UI_ASN_OVER_EDI_BOOKING = "enableUiAsnOverEdiBooking"
}

export class AppConfig{

    private static readonly frameworkStage = (window as any).ARGO_CONFIG?.argo?.frameworkStage;
    private static readonly cellInfo = (window as any).ARGO_CONFIG?.argo?.cell;
    private static readonly configStageKey = AppConfig.frameworkStage + '.' + AppConfig.cellInfo;

    private static readonly CONFIG = AppConfigMapFile;

    /**
     *
     * @param configMap
     * @private
     */
    private constructor(public readonly configMap: Map<string, Map<string,string>>) {
    }

    public static getConfigValue(configKey: AppConfigMapKey) {
        return AppConfig.CONFIG[this.configStageKey] ? AppConfig.CONFIG[this.configStageKey][configKey.toString()] : null;
    }

    public static isProd() {
        return "prod.cell-4" === AppConfig.configStageKey;
    }
}
